/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';

import { Link, Grid } from '@mui/material';

import ModalComponent from '../Modal';

class AppFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenVATPopup: false,
    };
  }

  handlePrivacyClick = () => {
    this.setState({ isOpenVATPopup: true });
  };

  handleClose = () => {
    this.setState({ isOpenVATPopup: false });
  };

  render() {
    const { isOpenVATPopup } = this.state;
    return (
      <footer
        style={{
          textAlign: 'center',
          padding: '20px',
          backgroundColor: '#ffffff',
          borderTop: '1px solid lightgray',
          position: 'fixed',
          bottom: 0,
          right: 0,
          left: 0,
        }}
      >
        <Grid container direction="row" justifyContent="center" alignItems="center" spacing={2}>
          <Grid item>
            <Link
              href="https://careers.habtoormotors.com/content/Privacy/?locale=en_GB"
              style={{ textDecoration: 'none' }}
            >
              Privacy
            </Link>
          </Grid>
          <Grid item>
            <Link
              href="https://careers.habtoormotors.com/content/Terms-of-Use/?locale=en_GB"
              style={{ textDecoration: 'none' }}
            >
              Terms of Use
            </Link>
          </Grid>
          <Grid item>
            <Link
              href="https://careers.habtoormotors.com/content/Copyright/?locale=en_GB"
              style={{ textDecoration: 'none' }}
            >
              Copyright
            </Link>
          </Grid>
          <Grid item>
            <Link href="#" style={{ textDecoration: 'none' }} onClick={this.handlePrivacyClick}>
              VAT Regulation
            </Link>
          </Grid>
        </Grid>
        <ModalComponent isOpen={isOpenVATPopup} onClose={this.handleClose} />
      </footer>
    );
  }
}

export default AppFooter;
